export const DEFAULT_DIAGRAM_LANGUAGE = 'en';

export interface DiagramLanguageOption {
  label: string;
  value: string;
}

export const DIAGRAM_LANGUAGE_OPTIONS: DiagramLanguageOption[] = [
  {label: 'English', value: 'en'},
  {label: 'Hindi', value: 'hi'},
  {label: 'Spanish', value: 'es'},
  {label: 'French', value: 'fr'},
  {label: 'Portuguese', value: 'pt'},
  {label: 'Japanese', value: 'ja'},
  {label: 'German', value: 'de'},
  {label: 'Turkish', value: 'tr'},
  {label: 'Italian', value: 'it'}
];
